export default "__VITE_ASSET__DckPkUdX__"